import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { redirect, useParams, useSearchParams } from 'react-router-dom'
function Redirector() {
  const { id } = useParams();
  const [message, setMessage] = useState("");
  const [error, setError] = useState(true);
  useEffect(() => {
    const response = async () => {

      axios.post(process.env.REACT_APP_REDIRECTOR, {
        shortUrl: id
      },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }).then(redirection => {
          window.open(redirection.data.toString(), "_self");
          if (redirection.data.length == 0) {
            setMessage("No end point found");
            setError(false);
            return;
          }
        })
    }

    response();

  }, [id]);

  return (
    <center><p>{error ? "Re-directing... " : ""}<br />{message}</p></center>
  )
}

export default Redirector